export default {
  'biosteel.ca': ['CA'],
  'www.biosteelsports.de': ['DE', 'AT'],
  'www.biosteel.com.cn': ['CN', 'HK', 'TW'],
  'biosteel.fi': ['FI'],
  'www.biosteelsports.co.uk': ['GB', 'UK'],
  'biosteel.se': ['SE'],
  'biosteel.com': '*',
};